"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalConfig = exports.withConfirm = exports.withDelete = exports.withError = exports.withSuccess = exports.withInfo = exports.withWarn = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var ReactDOM = tslib_1.__importStar(require("react-dom"));
var PromptCheckCircleFill_1 = require("../../Icons/PromptCheckCircleFill");
var PromptCloseCircleFill_1 = require("../../Icons/PromptCloseCircleFill");
var PromptErrorFill_1 = require("../../Icons/PromptErrorFill");
var PromptInfoCircleFill_1 = require("../../Icons/PromptInfoCircleFill");
var PromptWarningCircleFill_1 = require("../../Icons/PromptWarningCircleFill");
var ConfirmDialog_1 = tslib_1.__importDefault(require("./ConfirmDialog"));
var locale_1 = require("./locale");
var Modal_1 = require("./Modal");
var defaultRootPrefixCls = 'anq';
function getRootPrefixCls() {
    return defaultRootPrefixCls;
}
function confirm(config) {
    var div = document.createElement('div');
    document.body.appendChild(div);
    // eslint-disable-next-line @typescript-eslint/no-use-before-define
    var currentConfig = tslib_1.__assign(tslib_1.__assign({}, config), { close: close, visible: true });
    function destroy() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        var triggerCancel = args.some(function (param) { return param && param.triggerCancel; });
        if (config.onCancel && triggerCancel) {
            config.onCancel.apply(config, tslib_1.__spreadArray([], tslib_1.__read(args), false));
        }
        for (var i = 0; i < Modal_1.destroyFns.length; i++) {
            var fn = Modal_1.destroyFns[i];
            // eslint-disable-next-line @typescript-eslint/no-use-before-define
            if (fn === close) {
                Modal_1.destroyFns.splice(i, 1);
                break;
            }
        }
    }
    function render(_a) {
        var okText = _a.okText, cancelText = _a.cancelText, prefixCls = _a.prefixCls, props = tslib_1.__rest(_a, ["okText", "cancelText", "prefixCls"]);
        setTimeout(function () {
            var runtimeLocale = (0, locale_1.getConfirmLocale)();
            ReactDOM.render(React.createElement(ConfirmDialog_1.default, tslib_1.__assign({}, props, { prefixCls: prefixCls || "".concat(getRootPrefixCls(), "-modal"), rootPrefixCls: getRootPrefixCls(), okText: okText || (props.okCancel ? runtimeLocale.okText : runtimeLocale.justOkText), cancelText: cancelText || runtimeLocale.cancelText })), div);
        });
    }
    function close() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        currentConfig = tslib_1.__assign(tslib_1.__assign({}, currentConfig), { visible: false, afterClose: function () {
                if (typeof config.afterClose === 'function') {
                    config.afterClose();
                }
                // @ts-ignore
                destroy.apply(_this, args);
            } });
        render(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') {
            currentConfig = configUpdate(currentConfig);
        }
        else {
            currentConfig = tslib_1.__assign(tslib_1.__assign({}, currentConfig), configUpdate);
        }
        render(currentConfig);
    }
    render(currentConfig);
    Modal_1.destroyFns.push(close);
    return {
        destroy: close,
        update: update,
    };
}
exports.default = confirm;
function withWarn(props) {
    return tslib_1.__assign(tslib_1.__assign({ icon: React.createElement(PromptWarningCircleFill_1.PromptWarningCircleFill, { style: { color: '#FF7300' } }), okCancel: false }, props), { type: 'warning' });
}
exports.withWarn = withWarn;
function withInfo(props) {
    return tslib_1.__assign(tslib_1.__assign({ icon: React.createElement(PromptInfoCircleFill_1.PromptInfoCircleFill, { style: { color: '#4C67FF' } }), okCancel: false }, props), { type: 'info' });
}
exports.withInfo = withInfo;
function withSuccess(props) {
    return tslib_1.__assign(tslib_1.__assign({ icon: React.createElement(PromptCheckCircleFill_1.PromptCheckCircleFill, { style: { color: '#00B400' } }), okCancel: false }, props), { type: 'success' });
}
exports.withSuccess = withSuccess;
function withError(props) {
    return tslib_1.__assign(tslib_1.__assign({ icon: React.createElement(PromptCloseCircleFill_1.PromptCloseCircleFill, { style: { color: '#FF1818' } }), okCancel: false }, props), { type: 'error' });
}
exports.withError = withError;
function withDelete(props) {
    return tslib_1.__assign(tslib_1.__assign({ icon: React.createElement(PromptErrorFill_1.PromptErrorFill, { style: { color: '#FF7300' } }), okCancel: true }, props), { okText: props.okText || '确定删除', type: 'delete' });
}
exports.withDelete = withDelete;
function withConfirm(props) {
    return tslib_1.__assign(tslib_1.__assign({ icon: React.createElement(PromptErrorFill_1.PromptErrorFill, { style: { color: '#FF7300' } }), okCancel: true }, props), { type: 'confirm' });
}
exports.withConfirm = withConfirm;
function globalConfig(_a) {
    var rootPrefixCls = _a.rootPrefixCls;
    if (rootPrefixCls) {
        defaultRootPrefixCls = rootPrefixCls;
    }
}
exports.globalConfig = globalConfig;
//# sourceMappingURL=confirm.js.map